var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"height":"350px"}},[(_vm.loaded)?_c('e-chart',{staticStyle:{"width":"100%","max-height":"100%","padding-top":"1rem"},attrs:{"option":_vm.opts,"autoresize":true,"theme":_vm.darkmode ? 'sensoronlinedark' : 'macarons'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }